import TrelloModel from 'app/scripts/models/internal/trello-model.coffee';

class CustomEmoji extends TrelloModel {
  static initClass() {
    this.prototype.typeName = 'CustomEmoji';
  }
}
CustomEmoji.initClass();

export { CustomEmoji };
